import { KuposDatePicker, KuposErrorSuccessModal, KuposInput, KuposModal, SvgHome } from "../../../common";
import React, { useState } from "react";

import CommonService from "../../../../services/commonService";
import DateService from "../../../../services/dateService";
import getIcons from "../../functions/getIcons/getIcons";

const CancelTicketInput = props => {
	const { t, history, operator } = props.data;
	// Initialize state

	const [state, setState] = useState({
		pnr: '',
		email: '',
		date: DateService.getTodayString(),
		tnc: false,
		ticketDetailError: false,
		cancelTicketErrorMessage: '',
		pnrError: '',
		emailError: '',
	});

	const [pnrPopup, setPnrPopup] = useState(false);

	console.log(state);
	const search = () => {
		let valid = true;

		if (!state.pnr) {
			setState(prevState => ({ ...prevState, pnrError: 'Ingrese el número de boleto' }));
			valid = false;
		} else {
			setState(prevState => ({ ...prevState, pnrError: '' }));
		}

		if (!state.email) {
			setState(prevState => ({ ...prevState, emailError: 'Ingrese correo electrónico' }));
			valid = false;
		} else {
			setState(prevState => ({ ...prevState, emailError: '' }));
		}

		if (!valid) return;

		const dataChangeTicket = `pnr_number=${state.pnr}&contact_info=${state.email}&travel_date=${state.date}&is_change_ticket=${props.changeTicket}&do_cancel=true`;
		const dataCancelTicket = `pnr_number=${state.pnr}&contact_info=${state.email}&travel_date=${state.date}&do_cancel=true`;
		const encryptedData = props.changeTicket
			? window.btoa(dataChangeTicket)
			: window.btoa(dataCancelTicket);

		loadTicketDetails(encryptedData);
	};
	const loadTicketDetails = encryptedData => {
		console.log('propsinloadTicket', props);
		try {
			var decryptedData = window.atob(encryptedData);
			console.log('decrypted data is', decryptedData);
			// if (this.key) {
			// props.data.actions.apiCall({
			//   url: ApiUrls.ticketDetailsWithPath(decryptedData),
			//   callback: res => loadTicketDetailsResponse(res, encryptedData),
			//   type: 'home',
			// });
			let pathObj = CommonService.queryToObject(decryptedData);
			CommonService.loadEncTicketDetails(pathObj, props.data.actions.apiCall, res => {
				loadTicketDetailsResponse(res, encryptedData);
			});
			// }
		} catch (e) {
			console.log('error', e);
			// window.location.replace(window.location.origin);
			// props.actions.setTicketDetails('no data')
		}
	};

	const loadTicketDetailsResponse = (res, encryptedData) => {
		console.log('ticketres----', res);
		if (res && res.body && res.body.pay_gay_info && res.body.pay_gay_info.pay_gay_type === 0) {
			setState({
				...state,
				showModal: true,
				responseMessage: "Este pasaje solo puede ser anulado en la plataforma donde fue adquirido. ",
			});
			return; // Stop further execution
		}
		if (res && res.success && res.body && res.body.pnr_number && res.body.operator_id == operator.operator_id) {
			console.log('ticketres', res, encryptedData);
			props.data.actions.setTicketDetails(res.body);
			history.push('/modify-ticket/cancel?key=' + encryptedData);
		}

		if (res && res.success && res.body && res.body.pnr_number && res.body.operator_id !== operator.operator_id) {
			setState({
				...state,
				ticketDetailError: true,
				cancelTicketErrorMessage: "No tenemos resultados con los datos compartidos. Por favor revise su información nuevamente",
			});
		}

		if (!res.success && res.body) {
			props.data.actions.setTicketDetails('no data');
			// this.setState({
			//   cancelTicketModal: true,
			//   cancelTicketTitle: 'Anulación de pasaje',
			//   cancelTicketBodyody: res.data.body.message,
			//   showDetails: false
			// })
			setState({
				...state,
				ticketDetailError: true,
				cancelTicketErrorMessage: res.body.message,
			});
		}
	};

	const handlePnrPopup = () => {
		setPnrPopup(!pnrPopup);
	};

	return (
		<div>
			<div className="home-selection-input-boxes">
				<div className="home-selection-input-box font10">
					{/* <span className="label font11">Nº de Reserva</span> */}
					<span className={operator && operator.operator_name === "pullmandelsur" ? "label font11 bold-text" : "label font11"}>Nº de Reserva</span>
					<KuposInput
						inputStyle={{ border: '1px solid lightgray', borderRadius: '10px' }}
						type="text"
						placeholder="Numero de reserva"
						value={state.pnr}
						//onChange={(e) => setState({ ...state, pnr: e.target.value })}
						// onClick={handlePnrPopup}
						onChange={pnr => setState({ ...state, pnr })}
					/>
					{(operator && operator.operator_name === "santarosa") || (operator && operator.operator_name === "losnavegadores") || (operator && operator.operator_name === "buseslafit") || (operator && operator.operator_name === "basetorres") ?
						(<span
							onClick={handlePnrPopup}
							style={{
								position: 'absolute',
								right: '14px',
								top: '50%',
								transform: 'translateY(-34%)',
								cursor: 'pointer',
							}}
							className="pnricon"
						>
							<img src="/assets/santarosa/icons/information-icon.svg" />
						</span>) : null
					}
					{state.pnrError && <span className="error font9">{state.pnrError}</span>}
				</div>
				<div className="home-selection-input-box font10">
					{/* <span className="label font11">Correo electrónico</span> */}
					<span className={operator && operator.operator_name === "pullmandelsur" ? "label font11 bold-text" : "label font11"}>Correo electrónico</span>

					<KuposInput
						inputStyle={{ border: '1px solid lightgray', borderRadius: '10px' }}
						type="email"
						placeholder="Correo electronico"
						value={state.email}
						//onChange={(e) => setState({ ...state, email: e.target.value })}
						onChange={email => setState({ ...state, email })}
					/>
					{/* {operator && operator.operator_name === "santarosa" || operator && operator.operator_name === "buseslafit" ?
						(<span
							onClick={handlePnrPopup}
							style={{
								position: 'absolute',
								left: '10px',
								top: '50%',
								transform: 'translateY(-50%)',
								cursor: 'pointer',
							}}
						>
							<img src="/assets/santarosa/icons/important.png" />
						</span>) : null
					} */}
					{state.emailError && <span className="error font9">{state.emailError}</span>}
				</div>

				<div className="home-selection-input-box font10 datebox">
					{/* <span className="label font11">Fecha de viaje</span> */}
					<span className={operator && operator.operator_name === "pullmandelsur" ? "label font11 bold-text" : "label font11"}>Fecha de viaje</span>


					<KuposDatePicker
						// selectedDate={home.onwardPBDate ? home.onwardPBDate : DateService.getTodayString()}
						selectedDate={state.date}
						onDateChange={date => setState({ ...state, date })}
						minDate={DateService.getTodayString()}
						// error={error.date ? true : false}
						// errorMessage={error.date}
						placeholder={t('HOME.SELECT_DATE')}
						t={t}
					/>
				</div>

				<div className="home-selection-input-box font12 datebox">
					<button
						style={{
							background:
								operator && operator.color_codes && operator.color_codes.button_color
									? operator.color_codes.button_color
									: '',
						}}
						className="kupos-button home-selection-input-button "
						onClick={search}
					>
						<img src={getIcons('Search', operator)} alt="" />
						<span>{t('HOME.SEARCH')}</span>
						{/* <span className={operator && operator.operator_name === "pullmandelsur" ? "CAMBIAR" : "BUSCAR"}>CAMBIAR</span> */}

					</button>
				</div>
			</div>
			{
				state.ticketDetailError && (
					<div className="pnr font10" style={{ color: 'red' }}>
						{state.cancelTicketErrorMessage ? state.cancelTicketErrorMessage : 'Error'}
					</div>
				)
			}
			{
				(operator && operator.operator_name === "santarosa") || (operator && operator.operator_name === "buseslafit") || (operator && operator.operator_name === "losnavegadores") || (operator && operator.operator_name === "basetorres") ?
					("") : (<div className="pnr font10" onClick={handlePnrPopup}>
						¿Dónde encontrar mi número de reserva?
					</div>)
			}

			<KuposErrorSuccessModal
				success={state.status == 200 ? true : false}
				showModal={state.showModal}
				onButtonClick={() => {
					setState({ showModal: false });
					// window.location.reload();
				}}
				bodyText={state.responseMessage}
				generalButton="OK VOLVER"
			/>


			<div className="checkbox  ">
				<KuposModal
					ariaLabel="tnc-pnr-modal-outer"
					size={pnrPopup ? 'lg' : 'xl'}
					onHide={() => setPnrPopup(!pnrPopup)}
					showModal={pnrPopup}
				>
					<div className="tnc-pnr-modal">
						{pnrPopup && <img src={getIcons('pnr', operator)} alt="" />}
						<div className="close-button pointer" onClick={() => setPnrPopup(!pnrPopup)}>
							<SvgHome name="close" />
						</div>
					</div>
				</KuposModal>
			</div>
		</div >
	);
};


export default CancelTicketInput


// WEBPACK FOOTER //
// ./src/features/themes/ThemeTen/components/cancel-input.js